import { Navigate, useParams } from 'react-router'

export function PhonePage() {
  const { phoneNumber: rawParam } = useParams()
  const phoneNumber = decodeURIComponent(rawParam ?? '')

  if (!phoneNumber) {
    return <Navigate to="/app/calls/stage" replace />
  }

  return <Navigate to={`/app/calls/stage/${encodeURIComponent(phoneNumber)}`} replace />
}
